import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./tests.scss";

const fallbackData = {
  backToTests: "Back to tests",
  minuteShort: "min",
  answerAllQuestions: "Please answer every question before submitting.",
  answerAllInSection: "Энэ хэсгийн бүх асуултад хариулна уу.",
  submit: "Submit",
  retake: "Retake",
  results: "Results",
  audioPlaybackError: "Дуу ачааллахад алдаа гарлаа. Хуудсыг дахин ачаалаад оролдоно уу.",
  items: {},
};

const mnSelfAssessmentText = {
  "Self-assess your overall Writing band.": "Writing хэсгийн ерөнхий оноогоо өөрөө үнэлнэ үү.",
  "Base your score on these IELTS Writing criteria:": "Оноогоо IELTS Writing-ийн дараах шалгуурт үндэслэнэ үү:",
  "Task achievement / task response": "Даалгаврын биелэлт / хариулт",
  "Coherence and cohesion": "Уялдаа холбоо ба зохион байгуулалт",
  "Lexical resource": "Үгийн сангийн хэрэглээ",
  "Grammatical range and accuracy": "Дүрмийн хүрээ ба зөв хэрэглээ",
  "Self-assess your overall Speaking band.": "Speaking хэсгийн ерөнхий оноогоо өөрөө үнэлнэ үү.",
  "Base your score on these IELTS Speaking criteria:": "Оноогоо IELTS Speaking-ийн дараах шалгуурт үндэслэнэ үү:",
  "Fluency and coherence": "Ярианы урсгал ба уялдаа",
  "Pronunciation": "Дуудлага",
  "Expert": "Маш өндөр түвшин",
  "Very good": "Маш сайн",
  "Good": "Сайн",
  "Competent": "Дундаас дээш",
  "Modest": "Дундаж",
  "Limited": "Хязгаарлагдмал",
  "Very limited": "Маш хязгаарлагдмал",
  "Intermittent": "Тасалдсан хэрэглээтэй",
  "Non-user": "Хэрэглээ бараг байхгүй",
  "Did not attempt": "Оролдоогүй",
  "Fully answers every part of the task with a precise, well-developed position.": "Даалгаврын бүх хэсэгт бүрэн, тодорхой, сайн хөгжүүлсэн байр суурьтай хариулсан.",
  "Organises ideas naturally with clear paragraphing and effortless progression.": "Санаагаа ойлгомжтой догол мөрөөр, байгалийн уялдаатайгаар зохион байгуулсан.",
  "Uses flexible, precise vocabulary with very rare word-choice problems.": "Үгийн сангаа уян хатан, оновчтой хэрэглэсэн; үг сонголтын алдаа маш ховор.",
  "Uses a wide grammar range accurately; errors are rare and minor.": "Дүрмийн өргөн хүрээг зөв хэрэглэсэн; алдаа ховор бөгөөд жижиг.",
  "Answers the task well with relevant, extended ideas.": "Даалгаварт сайн хариулж, холбоотой санааг дэлгэрүүлсэн.",
  "Sequences information logically with strong cohesion and paragraph control.": "Мэдээллийг логик дараалалтай, уялдаа сайтай, догол мөрийн зохион байгуулалттай өгсөн.",
  "Uses a wide vocabulary range with only occasional awkward collocation.": "Өргөн үгийн сан хэрэглэсэн; үг хослолын эвгүй хэрэглээ хааяа гарсан.",
  "Uses varied complex grammar; most sentences are error-free.": "Олон төрлийн нийлмэл дүрэм хэрэглэсэн; ихэнх өгүүлбэр алдаагүй.",
  "Covers the task and presents a clear position, though support may be uneven.": "Даалгаврыг хамарч, тодорхой байр суурь илэрхийлсэн ч дэмжих санаа жигд биш байж болно.",
  "Organises ideas clearly, with some overuse or underuse of linking.": "Санааг ойлгомжтой зохион байгуулсан ч холбох үгсийг заримдаа хэтрүүлсэн эсвэл дутуу хэрэглэсэн.",
  "Uses enough less common vocabulary, with occasional inaccurate word choice.": "Нэлээд өргөн үгийн сан хэрэглэсэн ч зарим үг сонголт оновчгүй.",
  "Uses complex sentences, but errors still appear.": "Нийлмэл өгүүлбэр хэрэглэсэн боловч алдаа байсаар байна.",
  "Addresses the task, but ideas may be general or not fully developed.": "Даалгаварт хариулсан ч санаа ерөнхий эсвэл бүрэн хөгжөөгүй байж болно.",
  "Overall organisation is clear, though cohesion may be mechanical.": "Ерөнхий зохион байгуулалт ойлгомжтой ч уялдаа заримдаа механик байна.",
  "Vocabulary is adequate for the topic, with noticeable errors.": "Сэдэвт хангалттай үгийн сантай боловч мэдэгдэхүйц алдаатай.",
  "Mixes simple and complex grammar; errors sometimes reduce clarity.": "Энгийн ба нийлмэл дүрмийг хослуулсан ч алдаа заримдаа ойлгомжийг бууруулна.",
  "Partly answers the task, but key points may be missing or unclear.": "Даалгаварт хэсэгчлэн хариулсан ч гол санаа дутуу эсвэл тодорхойгүй байж болно.",
  "Has basic paragraphing, but progression can be weak or repetitive.": "Үндсэн догол мөрийн бүтэцтэй ч санааны хөгжил сул эсвэл давтагдсан байж болно.",
  "Uses limited vocabulary and repeats common words.": "Хязгаарлагдмал үгийн сан хэрэглэж, нийтлэг үгсийг давтсан.",
  "Frequent grammar errors occur, though the main message is often understandable.": "Дүрмийн алдаа олон гардаг ч гол санаа ихэвчлэн ойлгогдоно.",
  "Responds only minimally or misses important parts of the task.": "Маш бага хэмжээнд хариулсан эсвэл даалгаврын чухал хэсгийг орхисон.",
  "Ideas are difficult to follow because organisation is weak.": "Зохион байгуулалт сул тул санааг дагахад хүндрэлтэй.",
  "Vocabulary is basic and often inaccurate.": "Үгийн сан энгийн бөгөөд ихэвчлэн оновчгүй.",
  "Grammar errors are frequent and often make meaning unclear.": "Дүрмийн алдаа олон бөгөөд утгыг байнга тодорхойгүй болгоно.",
  "Does not adequately address the task.": "Даалгаварт хангалттай хариулаагүй.",
  "Shows little logical organisation.": "Логик зохион байгуулалт маш бага.",
  "Uses a very limited range of words.": "Маш хязгаарлагдмал үгийн сан хэрэглэсэн.",
  "Frequent errors make much of the response hard to understand.": "Олон алдаанаас болж хариултын ихэнх хэсгийг ойлгоход хэцүү.",
  "Barely responds to the task.": "Даалгаварт бараг хариулаагүй.",
  "Ideas are mostly disconnected.": "Санаанууд ихэвчлэн холбоогүй.",
  "Uses only isolated words or memorised phrases.": "Зөвхөн салангид үг эсвэл цээжилсэн хэллэг хэрэглэсэн.",
  "Grammar control is extremely limited and meaning is usually unclear.": "Дүрмийн хяналт маш хязгаарлагдмал бөгөөд утга ихэвчлэн тодорхойгүй.",
  "Provides almost no relevant task response.": "Даалгаварт холбоотой хариулт бараг өгөөгүй.",
  "Does not organise information into meaningful sentences.": "Мэдээллийг утгатай өгүүлбэр болгон зохион байгуулаагүй.",
  "Uses only a few recognisable words.": "Зөвхөн цөөн танигдахуйц үг хэрэглэсэн.",
  "Language is too limited to assess grammar accurately.": "Хэлний хэрэглээ хэт хязгаарлагдмал тул дүрмийг үнэлэхэд хангалтгүй.",
  "No answer is provided.": "Хариулт өгөөгүй.",
  "The response is fully off-topic or memorised.": "Хариулт бүрэн сэдвээс гадуур эсвэл цээжилсэн байна.",
  "The response is not written in English.": "Хариултыг англи хэлээр бичээгүй.",
  "There is not enough language to assess.": "Үнэлэхэд хангалттай хэлний хэрэглээ байхгүй.",
  "Speaks fluently with only very rare self-correction.": "Маш чөлөөтэй ярьж, өөрийгөө засах нь маш ховор.",
  "Develops topics fully and coherently.": "Сэдвийг бүрэн, уялдаатай хөгжүүлдэг.",
  "Uses precise, idiomatic vocabulary flexibly.": "Оновчтой, хэлцлэгтэй үгийн санг уян хатан хэрэглэдэг.",
  "Uses accurate grammar and pronunciation that is effortless to understand.": "Дүрэм, дуудлага зөв тул ойлгоход саадгүй.",
  "Speaks smoothly, with only occasional hesitation for language.": "Тогтвортой ярьдаг; хэлний шалтгаантай тээнэгэлзэл хааяа гарна.",
  "Develops relevant answers clearly.": "Холбоотой хариултыг тодорхой хөгжүүлдэг.",
  "Uses wide vocabulary and paraphrases effectively.": "Өргөн үгийн сан хэрэглэж, санааг өөрөөр үр дүнтэй илэрхийлдэг.",
  "Uses varied grammar and clear pronunciation with minor lapses.": "Олон төрлийн дүрэм, тод дуудлага хэрэглэдэг; жижиг алдаа хааяа гарна.",
  "Can speak at length without major loss of coherence.": "Уялдаа ихээр алдагдахгүйгээр урт ярьж чаддаг.",
  "Uses discourse markers and linking flexibly, though not always perfectly.": "Холбох хэллэгийг уян хатан хэрэглэдэг ч үргэлж төгс биш.",
  "Uses some less common vocabulary with occasional mistakes.": "Зарим түгээмэл бус үгийн сан хэрэглэдэг ч хааяа алдана.",
  "Uses a range of grammar and mostly clear pronunciation.": "Дүрмийн тодорхой хүрээтэй, дуудлага ихэнхдээ ойлгомжтой.",
  "Keeps speaking, but hesitation or repetition sometimes affects coherence.": "Яриагаа үргэлжлүүлдэг ч тээнэгэлзэл эсвэл давталт заримдаа уялдаанд нөлөөлнө.",
  "Has enough vocabulary for extended answers.": "Дэлгэрэнгүй хариулахад хангалттай үгийн сантай.",
  "Uses simple and complex grammar with frequent errors in complex forms.": "Энгийн болон нийлмэл дүрэм хэрэглэдэг ч нийлмэл хэлбэрт алдаа олон.",
  "Pronunciation is generally understandable, though control is variable.": "Дуудлага ерөнхийдөө ойлгомжтой ч хяналт тогтворгүй.",
  "Usually keeps going, but depends on repetition or self-correction.": "Ихэвчлэн үргэлжлүүлэн ярьдаг ч давталт эсвэл өөрийгөө засахад түшиглэдэг.",
  "Vocabulary is limited but enough for familiar topics.": "Үгийн сан хязгаарлагдмал ч танил сэдэвт хангалттай.",
  "Attempts complex grammar but often makes errors.": "Нийлмэл дүрэм хэрэглэхийг оролддог ч алдаа олон гаргадаг.",
  "Pronunciation requires some listener effort at times.": "Зарим үед сонсогчоос илүү анхаарал шаарддаг.",
  "Speech has frequent pauses and limited coherence.": "Яриа олон зогсолттой, уялдаа хязгаарлагдмал.",
  "Can express basic meaning mostly on familiar topics.": "Ихэнхдээ танил сэдвээр үндсэн утгыг илэрхийлж чадна.",
  "Uses repetitive sentence forms with frequent errors.": "Давтагдсан өгүүлбэрийн хэлбэр хэрэглэж, алдаа олон гаргадаг.",
  "Pronunciation problems often reduce clarity.": "Дуудлагын асуудал ойлгомжийг байнга бууруулдаг.",
  "Gives short, broken responses and cannot sustain discussion.": "Богино, тасархай хариулт өгч, яриаг үргэлжлүүлж чаддаггүй.",
  "Uses very limited vocabulary.": "Маш хязгаарлагдмал үгийн сан хэрэглэдэг.",
  "Grammar errors dominate the response.": "Дүрмийн алдаа хариултад давамгайлдаг.",
  "Pronunciation makes much of the answer hard to understand.": "Дуудлагаас болж хариултын ихэнх хэсгийг ойлгоход хэцүү.",
  "Can produce only isolated words or memorised phrases.": "Зөвхөн салангид үг эсвэл цээжилсэн хэллэг хэлж чадна.",
  "Cannot keep a conversation going.": "Харилцан яриаг үргэлжлүүлж чаддаггүй.",
  "Grammar and vocabulary are too limited for clear meaning.": "Дүрэм, үгийн сан тодорхой утга илэрхийлэхэд хэт хязгаарлагдмал.",
  "Pronunciation is mostly difficult to understand.": "Дуудлага ихэнхдээ ойлгоход хэцүү.",
  "Does not communicate beyond a few words.": "Цөөн үгээс цааш харилцаж чаддаггүй.",
  "Shows no sustained fluency or coherence.": "Тогтвортой урсгал, уялдаа байхгүй.",
  "Has almost no assessable vocabulary or grammar.": "Үнэлэхүйц үгийн сан, дүрэм бараг байхгүй.",
  "Pronunciation prevents reliable understanding.": "Дуудлага ойлголтыг найдвартай болгох боломжгүй.",
  "No spoken answer is provided.": "Аман хариулт өгөөгүй.",
  "The response is not spoken in English.": "Хариултыг англи хэлээр яриагүй.",
  "There is not enough speech to assess.": "Үнэлэхэд хангалттай яриа байхгүй."
};

const getProgressCacheKey = (testId) => `test-progress:${testId}`;

const readCachedProgress = (testId) => {
  if (typeof window === "undefined") return null;

  try {
    const rawProgress = window.localStorage.getItem(getProgressCacheKey(testId));
    if (!rawProgress) return null;

    const progress = JSON.parse(rawProgress);
    const answers = progress.answers && typeof progress.answers === "object" ? progress.answers : {};
    const responses = progress.responses && typeof progress.responses === "object" ? progress.responses : {};
    const results = progress.results && typeof progress.results === "object" ? progress.results : null;

    return {
      answers,
      responses,
      results,
      activeSectionId: typeof progress.activeSectionId === "string" ? progress.activeSectionId : "",
    };
  } catch (error) {
    return null;
  }
};

const writeCachedProgress = (testId, progress) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(
    getProgressCacheKey(testId),
    JSON.stringify({
      ...progress,
      updatedAt: new Date().toISOString(),
    })
  );
};

const clearCachedProgress = (testId) => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(getProgressCacheKey(testId));
};

const getLocalizedValue = (value, language) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return language === "mn" ? mnSelfAssessmentText[value] || value : value;
  }

  const fallbackValue = value[language] || value.en || value.mn || "";
  return language === "mn" ? mnSelfAssessmentText[fallbackValue] || fallbackValue : fallbackValue;
};

const writingImages = require.context("../../data/testdata/writing", false, /\.(png|jpe?g|webp)$/);
const writingImageSources = writingImages.keys().reduce((sources, filePath) => ({
  ...sources,
  [filePath.replace("./", "")]: writingImages(filePath),
}), {});

const DEFAULT_AUDIO_GAP_SECONDS = 0.5;

const roundIeltsBand = (score) => Math.round((score + Number.EPSILON) * 2) / 2;

const formatSectionScore = (test, score) => (
  test.scoringMode === "sum" ? Math.round(score) : score.toFixed(1)
);

const calculateOverallScore = (test, sectionResults) => {
  const total = sectionResults.reduce((sum, section) => sum + section.band, 0);

  if (test.scoringMode === "sum") {
    return Math.round(total);
  }

  return roundIeltsBand(total / sectionResults.length);
};

const SequencedAudioPlayer = ({ tracks, gapSeconds, unsupportedMessage, playbackErrorMessage }) => {
  const audioRef = useRef(null);
  const trackIndexRef = useRef(0);
  const gapTimeoutRef = useRef(null);
  const [playbackError, setPlaybackError] = useState(false);

  const clearGapTimeout = useCallback(() => {
    if (gapTimeoutRef.current) {
      clearTimeout(gapTimeoutRef.current);
      gapTimeoutRef.current = null;
    }
  }, []);

  const playTrackAtIndex = useCallback((index) => {
    const audio = audioRef.current;
    const track = tracks[index];
    if (!audio || !track?.source) return;

    trackIndexRef.current = index;
    setPlaybackError(false);
    audio.src = track.source;
    audio.load();
    audio.play().catch(() => {
      setPlaybackError(true);
    });
  }, [tracks]);

  useEffect(() => {
    trackIndexRef.current = 0;
    setPlaybackError(false);
    const audio = audioRef.current;
    if (audio && tracks[0]?.source) {
      audio.src = tracks[0].source;
      audio.load();
    }

    return () => {
      clearGapTimeout();
    };
  }, [tracks, clearGapTimeout]);

  const handleEnded = () => {
    const nextIndex = trackIndexRef.current + 1;
    if (nextIndex >= tracks.length) {
      trackIndexRef.current = tracks.length;
      return;
    }

    clearGapTimeout();
    gapTimeoutRef.current = setTimeout(() => {
      playTrackAtIndex(nextIndex);
    }, gapSeconds * 1000);
  };

  const handlePlay = () => {
    if (trackIndexRef.current >= tracks.length) {
      playTrackAtIndex(0);
    }
  };

  const handleError = () => {
    setPlaybackError(true);
  };

  if (playbackError) {
    return <p className="ielts-audio-player__status">{playbackErrorMessage}</p>;
  }

  return (
    <audio
      ref={audioRef}
      controls
      preload="metadata"
      onEnded={handleEnded}
      onPlay={handlePlay}
      onError={handleError}
    >
      {unsupportedMessage}
    </audio>
  );
};

const getWritingImageSource = (source) => {
  if (!source) return "";
  const normalizedSource = source.replace(/^\.\//, "");
  return writingImageSources[normalizedSource] || "";
};

const getAudioRecordingTracks = (recording) => {
  return (recording.tracks || [])
    .map((track) => ({
      ...track,
      source: track.src || "",
    }))
    .filter((track) => track.source);
};

const getSectionRecordings = (section) => {
  if (section.recordings?.length) return section.recordings;
  return section.audio ? [{ id: `${section.id}-recording`, ...section.audio }] : [];
};

const getSectionQuestions = (section) => [
  ...(section.questions || []),
  ...(section.parts || []).flatMap((part) => part.questions || []),
  ...getSectionRecordings(section).flatMap((recording) => recording.questions || []),
];

const IeltsMockTest = ({ test, data = fallbackData, language = "en" }) => {
  const [cachedProgress] = useState(() => readCachedProgress(test.id));
  const text = { ...fallbackData, ...data };
  const testText = {
    ...test,
    ...(text.items?.[test.id] || {}),
  };
  const [answers, setAnswers] = useState(cachedProgress?.answers || {});
  const [responses, setResponses] = useState(cachedProgress?.responses || {});
  const [results, setResults] = useState(cachedProgress?.results || null);
  const [activeSectionId, setActiveSectionId] = useState(() => {
    const cachedSectionId = cachedProgress?.activeSectionId;
    return test.sections.some((section) => section.id === cachedSectionId)
      ? cachedSectionId
      : test.sections[0]?.id || "";
  });
  const [error, setError] = useState("");
  const [highlightMissingIds, setHighlightMissingIds] = useState(() => new Set());
  const scrollMissingIntoViewAfterSubmitRef = useRef(false);
  const activeSection = test.sections.find((section) => section.id === activeSectionId) || test.sections[0];
  const ieltsItemText = text.items?.[test.id] || {};
  const submitButtonLabel =
    typeof ieltsItemText.submitButton === "string" ? ieltsItemText.submitButton : text.submit;

  useEffect(() => {
    const defaultSectionId = test.sections[0]?.id || "";
    const hasProgress = (
      Object.keys(answers).length > 0 ||
      Object.keys(responses).length > 0 ||
      Boolean(results) ||
      activeSectionId !== defaultSectionId
    );

    if (!hasProgress) {
      clearCachedProgress(test.id);
      return;
    }

    writeCachedProgress(test.id, {
      answers,
      responses,
      results,
      activeSectionId,
    });
  }, [activeSectionId, answers, responses, results, test.id, test.sections]);

  useEffect(() => {
    if (!test.sections.some((section) => section.id === activeSectionId)) {
      setActiveSectionId(test.sections[0]?.id || "");
    }
  }, [activeSectionId, test.sections]);

  const handleAnswerChange = (questionId, value) => {
    setAnswers((currentAnswers) => ({
      ...currentAnswers,
      [questionId]: value,
    }));
    setResults(null);
    setError("");
    setHighlightMissingIds((previous) => {
      if (!previous.has(questionId)) return previous;
      const next = new Set(previous);
      next.delete(questionId);
      return next;
    });
  };

  const handleResponseChange = (taskId, value) => {
    setResponses((currentResponses) => ({
      ...currentResponses,
      [taskId]: value,
    }));
    setResults(null);
    setError("");
    setHighlightMissingIds((previous) => {
      if (!previous.has(taskId)) return previous;
      const next = new Set(previous);
      next.delete(taskId);
      return next;
    });
  };

  const collectUnansweredIdsForSection = useCallback((section) => {
    if (!section) return [];

    const missing = [];

    if (section.assessmentType === "auto") {
      getSectionQuestions(section).forEach((question) => {
        if (answers[question.id] === undefined) missing.push(question.id);
      });
    }

    (section.tasks || []).forEach((task) => {
      const value = responses[task.id];
      if (value === undefined || String(value).trim() === "") missing.push(task.id);
    });

    if (section.scoreQuestion && answers[section.scoreQuestion.id] === undefined) {
      missing.push(section.scoreQuestion.id);
    }

    return missing;
  }, [answers, responses]);

  const collectAllUnansweredIds = () => (
    test.sections.flatMap((section) => collectUnansweredIdsForSection(section))
  );

  const findFirstSectionWithUnanswered = () => (
    test.sections.find((section) => collectUnansweredIdsForSection(section).length > 0) || null
  );

  const getBandFromScore = (section, correct) => {
    const band = (section.scoreBands || []).find((scoreBand) => correct >= scoreBand.minCorrect);
    return band?.band || 0;
  };

  const calculateResults = () => {
    if (collectAllUnansweredIds().length > 0) {
      setError(text.answerAllQuestions);
      return null;
    }

    setError("");
    const sectionResults = test.sections.map((section) => {
      if (section.assessmentType === "auto") {
        const questions = getSectionQuestions(section);
        const correct = questions.filter((question) => answers[question.id] === question.correctAnswer).length;

        return {
          id: section.id,
          title: getLocalizedValue(section.title, language),
          type: "auto",
          correct,
          total: questions.length,
          band: getBandFromScore(section, correct),
        };
      }

      const selectedBand = Number(answers[section.scoreQuestion.id]);
      const selectedOption = section.scoreQuestion.options.find((option) => Number(option.value) === selectedBand);

      return {
        id: section.id,
        title: getLocalizedValue(section.title, language),
        type: "manual",
        band: selectedBand,
        description: getLocalizedValue(selectedOption?.label, language),
      };
    });

    const average = sectionResults.reduce((total, section) => total + section.band, 0) / sectionResults.length;

    return {
      sectionResults,
      average,
      overallBand: calculateOverallScore(test, sectionResults),
    };
  };

  useEffect(() => {
    if (!scrollMissingIntoViewAfterSubmitRef.current || highlightMissingIds.size === 0) {
      return undefined;
    }

    const section = test.sections.find((entry) => entry.id === activeSectionId);
    if (!section) return undefined;

    const anchorId = collectUnansweredIdsForSection(section).find((id) => highlightMissingIds.has(id));

    if (!anchorId) {
      scrollMissingIntoViewAfterSubmitRef.current = false;
      return undefined;
    }

    scrollMissingIntoViewAfterSubmitRef.current = false;

    const frameId = window.requestAnimationFrame(() => {
      const element =
        document.getElementById(`ielts-q-${anchorId}`)
        || document.getElementById(`ielts-task-${anchorId}`);
      element?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [activeSectionId, answers, responses, highlightMissingIds, test.sections, collectUnansweredIdsForSection]);

  const handleSectionTabChange = (sectionId) => {
    setHighlightMissingIds(new Set());
    setError("");
    setActiveSectionId(sectionId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = () => {
    const section = activeSection;
    if (!section) return;

    const sectionMissing = collectUnansweredIdsForSection(section);
    if (sectionMissing.length > 0) {
      scrollMissingIntoViewAfterSubmitRef.current = true;
      setHighlightMissingIds(new Set(sectionMissing));
      setError(text.answerAllInSection);
      return;
    }

    setHighlightMissingIds(new Set());
    setError("");

    const sectionIndex = test.sections.findIndex((entry) => entry.id === section.id);
    const isLastSection = sectionIndex >= 0 && sectionIndex === test.sections.length - 1;

    if (!isLastSection) {
      const nextSection = test.sections[sectionIndex + 1];
      setActiveSectionId(nextSection.id);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const calculatedResults = calculateResults();
    if (!calculatedResults) {
      const allMissing = collectAllUnansweredIds();
      scrollMissingIntoViewAfterSubmitRef.current = true;
      setHighlightMissingIds(new Set(allMissing));
      const targetSection = findFirstSectionWithUnanswered();
      if (targetSection && targetSection.id !== activeSectionId) {
        setActiveSectionId(targetSection.id);
      }
      return;
    }

    setResults(calculatedResults);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleRetake = () => {
    setAnswers({});
    setResponses({});
    setResults(null);
    setError("");
    setHighlightMissingIds(new Set());
    setActiveSectionId(test.sections[0]?.id || "");
    clearCachedProgress(test.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderHeader = () => (
    <section className="upper-section">
      <div className="upper-section-inner">
        <div className="title-container">
          <h2>{getLocalizedValue(testText.title, language)}</h2>
        </div>
      </div>
    </section>
  );

  const renderAudioBlock = (recording) => {
    const audioTracks = getAudioRecordingTracks(recording);
    const hasConfiguredTracks = recording.tracks?.length > 0;
    if (!hasConfiguredTracks) return null;

    const unsupportedMessage = getLocalizedValue(recording.unsupportedMessage, language);
    const playbackErrorMessage = text.audioPlaybackError || "Дуу ачааллахад алдаа гарлаа. Хуудсыг дахин ачаалаад оролдоно уу.";

    return (
      <article className="ielts-audio-player">
        <div className="ielts-audio-player__header">
          <div>
            <h4>{getLocalizedValue(recording.audioTitle || recording.title, language)}</h4>
            {recording.audioInstructions ? (
              <p>{getLocalizedValue(recording.audioInstructions, language)}</p>
            ) : null}
          </div>
        </div>

        {audioTracks.length ? (
          <SequencedAudioPlayer
            tracks={audioTracks}
            gapSeconds={recording.gapSeconds ?? DEFAULT_AUDIO_GAP_SECONDS}
            unsupportedMessage={unsupportedMessage}
            playbackErrorMessage={playbackErrorMessage}
          />
        ) : (
          <p className="ielts-audio-player__status">
            {getLocalizedValue(recording.missingAudioMessage || recording.unsupportedMessage, language)}
          </p>
        )}
      </article>
    );
  };

  const renderTextBlock = (item) => {
    if (!item.content) return null;

    return (
      <article className="ielts-mock-text">
        {item.contentTitle ? <h4>{getLocalizedValue(item.contentTitle, language)}</h4> : null}
        {item.content.map((paragraph) => (
          <p key={paragraph}>{getLocalizedValue(paragraph, language)}</p>
        ))}
      </article>
    );
  };

  const renderRecording = (recording, questionStartIndex) => {
    const questions = recording.questions || [];

    return (
      <article key={recording.id} className="ielts-listening-part">
        <div className="ielts-listening-part__header">
          <h4>{getLocalizedValue(recording.title, language)}</h4>
          {recording.description ? <p>{getLocalizedValue(recording.description, language)}</p> : null}
        </div>
        {renderAudioBlock(recording)}
        {renderTextBlock(recording)}
        {questions.map((question, questionIndex) => renderQuestion(question, questionStartIndex + questionIndex))}
      </article>
    );
  };

  const renderContentPart = (part, questionStartIndex) => {
    const questions = part.questions || [];

    return (
      <article key={part.id} className="ielts-section-part">
        <div className="ielts-section-part__header">
          <h4>{getLocalizedValue(part.title, language)}</h4>
          {part.description ? <p>{getLocalizedValue(part.description, language)}</p> : null}
        </div>
        {renderTextBlock(part)}
        {questions.map((question, questionIndex) => renderQuestion(question, questionStartIndex + questionIndex))}
      </article>
    );
  };

  const renderQuestion = (question, index) => (
    <fieldset
      key={question.id}
      id={`ielts-q-${question.id}`}
      className={`test-question ielts-question${highlightMissingIds.has(question.id) ? " ielts-question--missing" : ""}`}
    >
      <legend>{index + 1}. {getLocalizedValue(question.prompt, language)}</legend>
      <div className="test-question__options ielts-question__options">
        {question.options.map((option) => (
          <label
            key={option.value}
            className={answers[question.id] === option.value ? "test-question__option--selected" : ""}
          >
            <input
              type="radio"
              name={question.id}
              value={option.value}
              checked={answers[question.id] === option.value}
              onChange={(event) => handleAnswerChange(question.id, event.target.value)}
            />
            <span>{getLocalizedValue(option.label, language)}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );

  const renderSectionContent = (section) => {
    const recordings = section.recordings || [];
    const parts = section.parts || [];

    if (recordings.length > 0) {
      let questionStartIndex = 0;
      return recordings.map((recording) => {
        const currentQuestionStartIndex = questionStartIndex;
        questionStartIndex += (recording.questions || []).length;
        return renderRecording(recording, currentQuestionStartIndex);
      });
    }

    if (parts.length > 0) {
      let questionStartIndex = 0;
      return parts.map((part) => {
        const currentQuestionStartIndex = questionStartIndex;
        questionStartIndex += (part.questions || []).length;
        return renderContentPart(part, currentQuestionStartIndex);
      });
    }

    return (
      <>
        {renderAudioBlock(getSectionRecordings(section)[0] || {})}
        {renderTextBlock(section)}
        {(section.questions || []).map(renderQuestion)}
      </>
    );
  };

  const renderTask = (task) => (
    <article
      key={task.id}
      id={`ielts-task-${task.id}`}
      className={`ielts-task${highlightMissingIds.has(task.id) ? " ielts-task--missing" : ""}`}
    >
      <div className="ielts-task__heading">
        <h4>{getLocalizedValue(task.title, language)}</h4>
        {task.wordGuidance ? <span>{getLocalizedValue(task.wordGuidance, language)}</span> : null}
      </div>
      {task.instructions ? <p>{getLocalizedValue(task.instructions, language)}</p> : null}
      {task.promptImage ? (
        <img
          className="ielts-task__prompt-image"
          src={getWritingImageSource(task.promptImage.src)}
          alt={getLocalizedValue(task.promptImage.alt, language)}
        />
      ) : (
        <p>{getLocalizedValue(task.prompt, language)}</p>
      )}
      <label>
        <span>{getLocalizedValue(task.responseLabel, language)}</span>
        <textarea
          value={responses[task.id] || ""}
          placeholder={getLocalizedValue(task.placeholder, language)}
          onChange={(event) => handleResponseChange(task.id, event.target.value)}
        />
      </label>
    </article>
  );

  const renderScoreQuestion = (section) => {
    if (!section.scoreQuestion) return null;

    const scoreQuestion = section.scoreQuestion;

    return (
      <fieldset
        id={`ielts-q-${scoreQuestion.id}`}
        className={`ielts-score-picker${highlightMissingIds.has(scoreQuestion.id) ? " ielts-score-picker--missing" : ""}`}
      >
        <legend>{getLocalizedValue(scoreQuestion.prompt, language)}</legend>
        <div className="ielts-score-picker__base">
          <strong>{getLocalizedValue(scoreQuestion.criteriaTitle, language)}</strong>
          <ul>
            {scoreQuestion.criteria.map((criterion) => (
              <li key={criterion}>{getLocalizedValue(criterion, language)}</li>
            ))}
          </ul>
        </div>
        <div className="ielts-score-picker__options">
          {scoreQuestion.options.map((option) => (
            <label
              key={option.value}
              className={Number(answers[scoreQuestion.id]) === Number(option.value) ? "ielts-score-picker__option--selected" : ""}
            >
              <input
                type="radio"
                name={scoreQuestion.id}
                value={option.value}
                checked={Number(answers[scoreQuestion.id]) === Number(option.value)}
                onChange={(event) => handleAnswerChange(scoreQuestion.id, event.target.value)}
              />
              <span className="ielts-score-picker__band">{language === "mn" ? "Түвшин" : "Band"} {option.value}</span>
              <span className="ielts-score-picker__label">{getLocalizedValue(option.label, language)}</span>
              <ul>
                {option.criteria.map((criterion) => (
                  <li key={criterion}>{getLocalizedValue(criterion, language)}</li>
                ))}
              </ul>
            </label>
          ))}
        </div>
      </fieldset>
    );
  };

  if (results) {
    return (
      <div className="items-container ielts-mock-test" id="tests">
        {renderHeader()}

        <main className="main-container test-runner test-runner--ielts">
          <Link to="/tests" className="test-runner__back">{text.backToTests}</Link>
          <section className="ielts-result" aria-live="polite">
            <div className="ielts-result__summary">
              <span>{getLocalizedValue(test.overallBandLabel, language)}</span>
              <h3>{formatSectionScore(test, results.overallBand)}</h3>
              <p>{getLocalizedValue(test.resultNote, language)}</p>
            </div>

            <div className="ielts-result__sections">
              {results.sectionResults.map((section) => (
                <article key={section.id} className="ielts-result-card">
                  <span>{section.title}</span>
                  <strong>{formatSectionScore(test, section.band)}</strong>
                  {section.type === "auto" ? (
                    <p>{section.correct}/{section.total} correct</p>
                  ) : (
                    <p>{section.description}</p>
                  )}
                </article>
              ))}
            </div>

            <p className="ielts-result__disclaimer">{getLocalizedValue(test.disclaimer, language)}</p>
            <button type="button" className="test-runner__submit" onClick={handleRetake}>{text.retake}</button>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div className="items-container ielts-mock-test" id="tests">
      {renderHeader()}

      <main className="main-container test-runner test-runner--ielts">
        <Link to="/tests" className="test-runner__back">{text.backToTests}</Link>
        <p className="test-runner__instructions">{getLocalizedValue(test.instructions, language)}</p>

        <div className="ielts-section-tabs" role="tablist" aria-label="IELTS mock test sections">
          {test.sections.map((section) => (
            <button
              key={section.id}
              type="button"
              id={`ielts-section-tab-${section.id}`}
              role="tab"
              aria-selected={section.id === activeSection?.id}
              aria-controls={`ielts-section-panel-${section.id}`}
              className={section.id === activeSection?.id ? "ielts-section-tabs__tab--active" : ""}
              onClick={() => handleSectionTabChange(section.id)}
            >
              <strong>{getLocalizedValue(section.title, language)}</strong>
              <span>{section.durationMinutes} {text.minuteShort}</span>
            </button>
          ))}
        </div>

        {activeSection ? (
          <section
            id={`ielts-section-panel-${activeSection.id}`}
            className="test-section ielts-section"
            role="tabpanel"
            aria-labelledby={`ielts-section-tab-${activeSection.id}`}
          >
            <div className="test-section__header">
              <h3>{getLocalizedValue(activeSection.title, language)}</h3>
              <span>{activeSection.durationMinutes} {text.minuteShort}</span>
            </div>
            {activeSection.instructions ? (
              <p className="ielts-section__instructions">{getLocalizedValue(activeSection.instructions, language)}</p>
            ) : null}

            {renderSectionContent(activeSection)}
            {(activeSection.tasks || []).map(renderTask)}
            {renderScoreQuestion(activeSection)}
          </section>
        ) : null}

        {error ? <p className="test-runner__error">{error}</p> : null}
        <button type="button" className="test-runner__submit" onClick={handleSubmit}>{submitButtonLabel}</button>
      </main>
    </div>
  );
};

export default IeltsMockTest;
